import {switchActive, toggle} from '../helpers/ActionHelper';
import {getIndex} from '../helpers/ElementHelper';
import {BaseRepository} from '../repositories/BaseRepository';
import {getCookie} from '../helpers/CookieHelper';

export class ResourcesGridComponent {
  container;

  mobileContainer;

  repository;

  baseData;

  prevGridItem;

  constructor() {
    this.container = document.querySelector('.c-resources-grid');
    this.mobileContainer = document.querySelector('.c-resources-grid-mobile');
    this.repository = new BaseRepository();
  }

  initialize() {
    if (!this.container) {
      return;
    }

    this.addEventListeners();

    this.setBaseData();

    this.handleOpenModalRequest();
  }

  addEventListeners() {
    const categories = [...this.container.querySelectorAll('.js-switch-tab')];
    categories.forEach((category) => {
      category.addEventListener('click', (e) => this.categoryClickHandler(e));
    });

    const viewMoreButtons = [...this.container.querySelectorAll('.js-view-more')];
    viewMoreButtons.forEach((viewMoreButton) => {
      viewMoreButton.addEventListener('click', (e) => this.viewMoreButtonClickHandler(e));
    });

    const viewMoreMobileButtons = [...this.mobileContainer.querySelectorAll('.js-view-more')];
    viewMoreMobileButtons.forEach((viewMoreMobileButton) => {
      viewMoreMobileButton.addEventListener('click', (e) => this.viewMoreMobileButtonClickHandler(e));
    });

    document.addEventListener('click', (e) => this.openModalClickHandler(e));

    window.addEventListener('message', (event) => {
      if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
        this.hsResourceFormSubmitHandler();
      }
    });
  }

  categoryClickHandler(e) {
    const target = e.target.closest('.js-switch-tab');
    if (!target) {
      return;
    }

    switchActive(target);

    const index = getIndex(target);

    const lists = [...this.container.querySelectorAll('.resource-list-outer')];
    switchActive(lists[index]);

    this.viewMoreUpdateMobileVisibility(index);
  }

  async viewMoreButtonClickHandler(e) {
    if (e.target.classList.contains('loading')) {
      return;
    }

    toggle(e.target, 'loading');

    const container = e.target.closest('.resource-list-outer');

    const data = {
      page: container.hasAttribute('data-current-page') ? parseInt(container.getAttribute('data-current-page')) : 1,
      last_page: container.hasAttribute('data-last-page') ? parseInt(container.getAttribute('data-last-page')) : 1,
      category_id: container.hasAttribute('data-category-id') ? parseInt(container.getAttribute('data-category-id')) : 0
    };

    this.increaseCurrentPage(container, data.page);

    data.page = container.hasAttribute('data-current-page') ? parseInt(container.getAttribute('data-current-page')) : 1;

    if (data.page >= data.last_page) {
      this.removeViewMoreButton(container);
    }

    const markup = await this.loadResourcesMarkup(data);

    if (markup) {
      this.appendGridMarkup(container, markup);
    }
  }

  async viewMoreMobileButtonClickHandler(e) {
    if (e.target.classList.contains('loading')) {
      return;
    }

    toggle(e.target, 'loading');

    const index = e.target.getAttribute('data-index');
    const containers = this.container.querySelectorAll('.resource-list-outer');
    const container = containers[index];

    const data = {
      page: container.hasAttribute('data-current-page') ? parseInt(container.getAttribute('data-current-page')) : 1,
      last_page: container.hasAttribute('data-last-page') ? parseInt(container.getAttribute('data-last-page')) : 1,
      category_id: container.hasAttribute('data-category-id') ? parseInt(container.getAttribute('data-category-id')) : 0
    };

    this.increaseCurrentPage(container, data.page);

    data.page = container.hasAttribute('data-current-page') ? parseInt(container.getAttribute('data-current-page')) : 1;

    if (data.page >= data.last_page) {
      this.removeViewMoreButton(container);
      e.target.remove();
    }

    const markup = await this.loadResourcesMarkup(data);

    if (markup) {
      this.appendGridMarkup(container, markup);
    }
  }

  openModalClickHandler(e) {
    const target = e.target.closest('.js-open-modal');
    if (!target) {
      return;
    }

    const container = target.closest('.resource-list__item');
    if (!container) {
      return;
    }

    this.prevGridItem = container;

    const isPublic = container.hasAttribute('data-is-public') ? Boolean(parseInt(container.getAttribute('data-is-public'))) : false;

    isPublic || getCookie('hs_is_known_user') ? this.openResourceModal(container) : this.openFormModal();
  }

  async hsResourceFormSubmitHandler() {
    const modalContainer = document.querySelector('.resource-modal-wrapper');
    if (!modalContainer) {
      return;
    }

    try {
      const {Fancybox} = await import('@fancyapps/ui' /*webpackChunkName: "fancy" */);
      Fancybox.default.getInstance().close();

      this.prevGridItem
          ? this.openResourceModal(this.prevGridItem)
          : this.noPrevGridItemHandler();
    } catch (error) {
      console.error('Error importing FancyBox:', error);
    }
  }

  async loadResourcesMarkup(data) {
    const response = await this.repository.post(this.getRequestData(data));

    return new Promise((resolve) => {
      resolve(response.data.markup);
    });
  }

  getRequestData(data) {
    const baseData = this.baseData;
    Object.assign(data, baseData);

    return data;
  }

  increaseCurrentPage(container, page) {
    container.setAttribute('data-current-page', ++page);
  }

  setBaseData() {
    const tokenInput = this.container.querySelector('input[name=_security_token]');
    const actionInput = this.container.querySelector('input[name=action]');

    this.baseData = {
      _security_token: tokenInput ? tokenInput.value : '',
      action: actionInput ? actionInput.value : ''
    };
  }

  handleOpenModalRequest() {
    const url = new URL(window.location.href);
    const action = url.searchParams.has('action') ? url.searchParams.get('action') : '';
    const resourceId = url.searchParams.has('resource_id') ? url.searchParams.get('resource_id') : 0;
    if (!action || !resourceId) {
      return;
    }

    const resourceElement = this.container.querySelector(`.resource-list__item-${resourceId}`);
    if (!resourceElement) {
      return;
    }

    getCookie('hs_is_known_user') ? this.openResourceModal(resourceElement) : this.openFormModal();
  }

  removeViewMoreButton(container) {
    const button = container.querySelector('.js-view-more');
    if (button) {
      button.remove();
    }
  }

  appendGridMarkup(container, markup) {
    const list = container.querySelector('.resource-list');

    if (list) {
      list.innerHTML = list.innerHTML + markup;
    }
  }

  async openResourceModal(container) {
    const src = container.hasAttribute('data-resource-url') ? container.getAttribute('data-resource-url') : '';
    if (!src) {
      return;
    }

    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.classList.add('resource-iframe');

    const wrapper = document.createElement('div');
    wrapper.classList.add('resource-modal-wrapper');
    wrapper.classList.add('contains-resource');

    wrapper.appendChild(iframe);

    try {
      const {Fancybox} = await import('@fancyapps/ui' /*webpackChunkName: "fancy" */);
      new Fancybox([{src: wrapper, type: 'html'}], {
        on: {
          'destroy': () => {
            this.removeModalFromHistory();
          }
        }
      });
    } catch (error) {
      console.error('Error importing FancyBox:', error);
    }

    this.addResourceModalToHistory(container);
  }


  async openFormModal() {
    if (typeof GP_PAGE_CONFIG === 'undefined') {
      return;
    }

    const modalData = GP_PAGE_CONFIG.hasOwnProperty('modal') ? GP_PAGE_CONFIG.modal : null;
    if (!modalData) {
      return;
    }

    const script = document.createElement('script');
    script.src = THEME_CONFIG.assets_url + '/forms/resource.js';

    const formWrapper = document.createElement('div');
    formWrapper.appendChild(script);

    const wrapper = document.createElement('div');
    wrapper.classList.add('resource-modal-wrapper');
    const innerWrapper = document.createElement('div');
    innerWrapper.classList.add('demo-form');
    innerWrapper.innerHTML += modalData.hasOwnProperty('title') ? `<h4 class="elementor-heading-title elementor-size-default">${modalData.title}</h4>` : '';
    innerWrapper.innerHTML += modalData.hasOwnProperty('description') ? modalData.description : '';
    innerWrapper.appendChild(formWrapper);

    wrapper.appendChild(innerWrapper);

    try {
      const {Fancybox} = await import('@fancyapps/ui' /*webpackChunkName: "fancy" */);
      new Fancybox([
        {
          src: wrapper,
          type: 'html'
        }
      ]);
    } catch (error) {
      console.error('Error importing FancyBox:', error);
    }
  }

  viewMoreUpdateMobileVisibility(index) {
    const activeButton = this.mobileContainer.querySelector(`.button_view-more.visible`);
    if (activeButton) {
      activeButton.classList.remove('visible');
    }

    const button = this.mobileContainer.querySelector(`.button_view-more-${index}`);
    if (button) {
      button.classList.add('visible');
    }
  }

  addResourceModalToHistory(container) {
    const url = new URL(window.location.href);
    url.searchParams.set('action', 'open_modal');
    url.searchParams.set('resource_id', container.getAttribute('data-id'));
    window.history.pushState({}, '', url);
  }

  removeModalFromHistory() {
    const url = new URL(window.location.href);
    url.searchParams.delete('action');
    url.searchParams.delete('resource_id');
    window.history.pushState({}, '', url);
  }

  noPrevGridItemHandler() {
    const url = new URL(window.location.href);
    const id = url.searchParams.has('resource_id') ? url.searchParams.get('resource_id') : 0;
    if (id < 1) {
      return;
    }

    this.prevGridItem = this.container.querySelector(`.resource-list__item-${id}`);
    if (this.prevGridItem) {
      this.openResourceModal(this.prevGridItem);
    }
  }
}